import React from 'react';
import youtubeshows from '../assets/portfolio/youtubeshows.jpg';
import apnidukan from '../assets/portfolio/apnidukan.JPG';
import portfolioimage from '../assets/portfolio/portimage.JPG';


const Projects = () => {
    const projects = [
        {
            id:1,
            src: youtubeshows,
            linkd : "https://youtubeshows.netlify.app/",
            linkc : "https://github.com/101AbhimanyuMagar/youtube_clone"
        },
        {
            id:2,
            src: apnidukan,
            linkd : "https://dukanapni.netlify.app/",
            linkc : "https://github.com/101AbhimanyuMagar/apni_dukan"
        },
        {
            id:3,
            src: portfolioimage,
            linkd : "/",
            linkc : "https://github.com/101AbhimanyuMagar/abhimanyumagar.git"
        }
    ]
    const newTab= (url=>{
        window.open(url);
    })
  return (
    <div name="projects"
        className='bg-gradient-to-b from-gray-800 to-black w-full text-white md:h-screen'>
        <div className='max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full'>
            <div className='pb-8'>
                <p className='text-4xl font-bold inline border-b-4 border-gray-500'>Projects</p>
                <p className='py-6 text-xl'>Check out some of my work right here</p>
            </div>
            
            <div className='grid sm:grid-cols-2 md:grid-cols-3 gap-8 px-12 sm:px-0'>
            {
                projects.map(({id, src, linkd, linkc})=>(
                    <div key={id} className='shadow-md shadow-gray-600 rounded-lg'>
                        <img 
                        src={src} 
                        alt="" 
                        className='rounded-md duration-200 hover:scale-105'/>
                        <div className='flex items-center justify-center'>
                            <button className='w-1/2 px-6 py-3 m-4 duration-200 hover:scale-105' onClick={()=>newTab(linkd)}>Demo</button>
                            <button className='w-1/2 px-6 py-3 m-4 duration-200 hover:scale-105'
                            onClick={()=>newTab(linkc)}>Code</button>
                        </div>
                    </div>
                ))
            }  
            </div>
        </div>
    </div>
  )
}

export default Projects